
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 6h16a1 1 0 000-2H7a1 1 0 000 2zm16 5H7a1 1 0 000 2h16a1 1 0 000-2zm0 7H7a1 1 0 000 2h16a1 1 0 000-2z"}}),_c('circle',{attrs:{"cx":"2","cy":"5","r":"2"}}),_c('circle',{attrs:{"cx":"2","cy":"12","r":"2"}}),_c('circle',{attrs:{"cx":"2","cy":"19","r":"2"}})])
          )
        }
      }
    